import { memo } from 'react';
import classnames from 'clsx';
import { Tabs as ReactTabs } from 'react-tabs';

import style from './tabs.module.css';

import type { TabsProps as ReactTabsProps } from 'react-tabs';
import type { ReactTabsMemoComponent } from 'ui-components/components/tabs/tabs-types';

export type TabsProps = Omit<ReactTabsProps, 'onSelect' | 'selectedIndex'> & {
  /** Callback when selected tab changes */
  onSelectedTabIndexChange?: (index: number) => void;
  /** Controlled selected tab index */
  selectedTabIndex?: number;
};

export const Tabs: ReactTabsMemoComponent<TabsProps> = memo(
  ({ children, className, onSelectedTabIndexChange, selectedTabIndex, defaultIndex, selectedTabClassName }) => (
    <ReactTabs
      className={classnames(style.tabs, className)}
      defaultFocus={false}
      defaultIndex={defaultIndex}
      disableUpDownKeys
      onSelect={onSelectedTabIndexChange}
      selectedIndex={selectedTabIndex}
      selectedTabClassName={selectedTabClassName}
    >
      {children}
    </ReactTabs>
  ),
);

Tabs.displayName = 'Tabs';
Tabs.tabsRole = 'Tabs';
